import React from 'react'

import moment from 'moment'
import '../../../assets/css/pharma.css';
import {getUserSettings} from '../../../storage'
import {inWords} from '../../../utils/misc'

class PurchasePharma extends React.Component {

  render() {

    let company = this.props.company
    let purchase = this.props.purchase
    let settings = getUserSettings()

    let purchase_date = moment(purchase.date).format('D-MM-YYYY')
    let billto, billFrom
    let shipping_address
    let optionalRow = false

    let table_cols
    if(purchase.is_igst) {
      table_cols = 12
    }
    else {
      table_cols = 14
    }
    let show_mrp_column = false
    let show_unit_price_column = true
    let show_expiry_date_column = false
    let show_container_unit = false
    if(typeof settings !== "undefined" && settings !== null) {
      if(settings.show_purchase_unit_price) {
        show_unit_price_column = true
      }
      else {
        show_unit_price_column = false
        table_cols = table_cols-1
      }

       if(settings.show_purchase_mrp_column) {
         show_mrp_column = true
         table_cols = table_cols+1
       }
       if(settings.show_purchase_container_info) {
         show_container_unit = true
       }

       if(settings.show_invoice_expiry_date) {
         show_expiry_date_column = true
         table_cols = table_cols+1
       }
    }


    let brandRow = <small><i>Generated with https://www.goodsbill.com</i></small>

    let transportSection

    let transportlabel = purchase.transportlabel
    if(typeof transportlabel !== "undefined" && transportlabel !== null) {

      let t_label_name, t_bill_no, t_lr_no, t_challan_no, t_vehicle_no, t_ship_by, t_transporter_name, t_transporter_id, t_transporter_gstin
      t_bill_no = transportlabel.bill_no
      t_label_name = transportlabel.label_name
      if(t_label_name === "way_bill_no") {
        t_label_name = <strong>Way Bill No: </strong>
      }
      else if(t_label_name === "e_sugam_no"){
        t_label_name = <strong>E Sugam No: </strong>
      }
      else if (t_label_name === "eway_bill_no") {
        t_label_name = <strong>EWay Bill No: </strong>
      }
      t_vehicle_no = transportlabel.vehicle_no
      if(typeof t_vehicle_no !== "undefined" && t_vehicle_no !== null && t_vehicle_no.length > 0) {
        t_vehicle_no = <span><strong>Vehicle No: </strong> {t_vehicle_no}</span>
      }
      t_challan_no = transportlabel.challan_no
      if(typeof t_challan_no !== "undefined" && t_challan_no !== null && t_challan_no.length > 0) {
        t_challan_no = <span><strong>Challan No: </strong> {t_challan_no}</span>
      }
      t_lr_no = transportlabel.lr_no
      if(typeof t_lr_no !== "undefined" && t_lr_no !== null && t_lr_no.length > 0 ) {
        t_lr_no = <span><strong>LR No: </strong> {t_lr_no}</span>
      }

      t_ship_by = transportlabel.ship_by
      if(typeof t_ship_by !== "undefined" && t_ship_by !== null && t_ship_by.length> 0) {
        t_ship_by = <span><strong>Ship By: </strong> {t_ship_by}</span>
      }
      t_transporter_name = transportlabel.transporter_name
      if(typeof t_transporter_name !== "undefined" && t_transporter_name !== null && t_transporter_name.length > 0) {
        t_transporter_name = <span><strong>Transporter Name: </strong> {t_transporter_name}</span>
      }
      t_transporter_id = transportlabel.transporter_id
      if(typeof t_transporter_id !== "undefined" && t_transporter_id !== null && t_transporter_id.length > 0) {
        t_transporter_id = <span><strong>Transporter ID: </strong> {t_transporter_id}</span>
      }
      t_transporter_gstin = transportlabel.transporter_gstin
      if(typeof t_transporter_gstin !== "undefined" && t_transporter_gstin !== null && t_transporter_gstin.length > 0) {
        t_transporter_gstin = <span><strong>Transporter GSTIN: </strong> {t_transporter_gstin}</span>
      }

      transportSection = <div>
          <ul className="list-inline">
            <li>{t_label_name} {t_bill_no}</li>
            <li>{t_vehicle_no}</li>
            <li>{t_lr_no}</li>
            <li>{t_challan_no}</li>
            <li>{t_ship_by}</li>
            <li>{t_transporter_name}</li>
            <li>{t_transporter_id}</li>
            <li>{t_transporter_gstin}</li>
          </ul>
      </div>
    }


    if(typeof purchase.supplier !== "undefined" && purchase.supplier !== null) {



      let supplier_gstin
      let supplier_phone
      if(typeof purchase.supplier.gstin !== "undefined" && purchase.supplier.gstin !== null && purchase.supplier.gstin.length > 0) {
        supplier_gstin = "GSTIN-"+purchase.supplier.gstin
      }
      if(typeof purchase.supplier.phone !== "undefined" && purchase.supplier.phone !== null && purchase.supplier.phone.length > 0) {
        supplier_phone = "Ph: " + purchase.supplier.phone
      }

      billFrom = <div >
        <div className="company-name text-uppercase">
          {purchase.supplier.name}
        </div>
        <div className="">

        <div className="company-address gray">
          <span className="company-state gray">{purchase.supplier.address}</span>
          <span className="company-state gray">{" "+purchase.supplier.city}</span>
        </div>
        <div>
        <span className="company-state gray">{" "+purchase.supplier.state}</span>
        <span className="company-pin gray">{" "+ purchase.supplier.pin}</span>
        <span className="company-phone gray">{" "+ purchase.supplier.phone}</span>
        </div>

        <div className="company-email gray">

        </div>

        <div className="company-state gray">
         {supplier_gstin}  <span className="gray"> State Code: {purchase.supplier.state_code}</span>
        </div>
        </div>

      </div>


    }
    
    let company_gstin

    if(typeof company.gstin !== "undefined" && company.gstin.length > 0) {
      company_gstin = <span className="gray">{"GSTIN-" +company.gstin}</span>
    }
    billto = <div className="row">

    <div className="col-xs-12">

      <div className="" style={{paddingTop:5}}>
      <strong>Bill To</strong>
        <div className="gray">
            {company.company_name}
        </div>
        <div className="gray">
            <span >{company.address} </span>
            <span >{" "+company.city}</span>
        </div>
        <div>
          <span className="gray">
          {company.state}
          </span>
          <span className="gray">
          {" "+company.pin}
          </span>

        </div>
        <div>
        </div>
        <div className="gray">
           {company_gstin}
        </div>
      </div>
    </div>

    </div>



    let items, summaryRow



    if(purchase.purchaseitem_set.length > 0) {

      purchase.purchaseitem_set.sort((a,b)=>{
        return a.tableIndex - b.tableIndex
      })

      items = purchase.purchaseitem_set.map((purchaseitem, index)=>{
        let discountCol, cgstcol, sgstcol, igstcol
        if(purchaseitem.discount_value > 0) {
            discountCol = <td className="text-right">{purchaseitem.discount_value}</td>
        }
        else {
          discountCol = <td className="text-right"></td>
        }

        if(purchase.is_igst) {
          if(purchaseitem.igst_amount > 0) {
            igstcol = <td colSpan={"2"} className="text-right">
              {parseFloat(purchaseitem.igst_amount).toFixed(2)} ({Number(purchaseitem.gst.igst)}%)

                 </td>
          }
          else {
            igstcol = <td colSpan={"2"} className="text-right"></td>
          }

        }
        else {

          if(purchaseitem.cgst_amount > 0) {
            cgstcol=  <td colSpan={"2"} className="text-right">
            {parseFloat(purchaseitem.cgst_amount).toFixed(2)} ({Number(purchaseitem.gst.cgst)}%)
               </td>
          }
          else {
            cgstcol= <td colSpan={"2"} className="text-right"></td>
          }

          if(purchaseitem.sgst_amount > 0) {
            sgstcol= <td colSpan={"2"} className="text-right">
                      {parseFloat(purchaseitem.sgst_amount).toFixed(2)} ({Number(purchaseitem.gst.sgst)}%)
                 </td>
          }
          else {
            sgstcol = <td colSpan={"2"} className="text-right"></td>
          }
        }

        let item_unit, container_info
        if(typeof purchaseitem.unit !== "undefined" && purchaseitem.unit !== null) {
          item_unit = purchaseitem.unit.primary_unit

          let container_unit = purchaseitem.unit.container_unit, container_unit_plural = purchaseitem.unit.container_unit_plural
          if(typeof container_unit !== "undefined" && container_unit !== null && container_unit.length > 0) {
            let container_volume = purchaseitem.unit.container_volume

            let containers = Math.trunc(purchaseitem.quantity/container_volume)
            if(containers > 1 && typeof container_unit_plural !== "undefined" && container_unit_plural !== null && container_unit_plural.length > 0) {
              container_unit = container_unit_plural
            }
            let pieces =  purchaseitem.quantity%container_volume

            if(pieces > 0) {

              container_info = <div> <div>{item_unit}</div>  <div>{containers} {container_unit} & {pieces} {item_unit}</div></div>
            }
            else{
              container_info = <div> {item_unit} ({containers} {container_unit})</div>
            }
          }
          else {
            // In case if container doesn't exist
            container_info = item_unit
          }

        }
        let unit_info
        if(show_container_unit) {
          unit_info = container_info
        }
        else {
          unit_info = item_unit
        }

        let unit_price = Number(purchaseitem.selling_basic_rate),
        taxable_price = parseFloat(purchaseitem.price).toFixed(2),
        item_total = parseFloat(purchaseitem.total).toFixed(2)

        let mrp_column, unit_price_column, exp_date_column
        if(show_mrp_column) {
          mrp_column = <td className="text-right">{parseFloat(purchaseitem.mrp).toFixed(2)}</td>
        }
        if(show_unit_price_column) {
          unit_price_column = <td className="text-right">{unit_price}</td>
        }
        if(show_expiry_date_column) {
          exp_date_column = <td className="text-right">{moment(purchaseitem.batch.expiry_date).format('MM/YY')}</td>
        }

        let batch_name
        if(typeof purchaseitem.batch !== "undefined" && purchaseitem.batch !== null) {
          batch_name = purchaseitem.batch.name
        }


        return <tr key={index}>
          <td>{purchaseitem.tableIndex}</td>
          <td><div>{purchaseitem.name}</div></td>
          <td><div>{purchaseitem.hsn}</div> </td>
          <td className="text-right">
            <div>{Number(purchaseitem.quantity)}</div>
          </td>
          <td>
            {unit_info}
          </td>
          <td>{batch_name}</td>
          {exp_date_column}
          {unit_price_column}
          {mrp_column}
          {discountCol}
          <td className="text-right">{taxable_price}</td>
            {cgstcol}{sgstcol}{igstcol}
          <td className="text-right">{item_total}</td>
      </tr>
      })


      let summaryQuantity=0, summaryDiscount=0, summaryTaxable=0, summaryIGST=0, summaryCGST=0, summarySGST=0, summaryTotal=0
      let percentages={cgst:{}, sgst:{}, igst:{}}
      for (var i = 0; i < purchase.purchaseitem_set.length; i++) {
          const si = purchase.purchaseitem_set[i]
          summaryQuantity = summaryQuantity + parseFloat(si.quantity)
          summaryDiscount = summaryDiscount + parseFloat(si.discount_value)
          summaryTaxable = summaryTaxable + parseFloat(si.price)
          summaryIGST = summaryIGST + parseFloat(si.igst_amount)
          summaryCGST = summaryCGST + parseFloat(si.cgst_amount)
          summarySGST = summarySGST + parseFloat(si.sgst_amount)
          summaryTotal = summaryTotal + parseFloat(si.total)


          const unique_cgst_pct = si.gst.cgst, unique_sgst_pct = si.gst.sgst, unique_igst_pct = si.gst.igst
          const igst_s_amount = parseFloat(si.igst_amount)
          const cgst_s_amount = parseFloat(si.cgst_amount)
          const sgst_s_amount = parseFloat(si.sgst_amount)
          const taxable_price = parseFloat(si.price)
          const total = parseFloat(si.total)

          let cgst_percentages = percentages['cgst']

          if(typeof cgst_percentages[unique_cgst_pct] !== "undefined") {
            let s = cgst_percentages[unique_cgst_pct]

            s.cgst_amount= s.cgst_amount + cgst_s_amount
            s.sgst_amount= s.sgst_amount + sgst_s_amount
            // s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total

          }
          else {
            cgst_percentages[unique_cgst_pct] = {cgst_amount:cgst_s_amount,  sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
            //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
          }
          percentages['cgst'] = cgst_percentages

          let igst_percentages = percentages['igst']

          if(typeof igst_percentages[unique_igst_pct] !== "undefined") {
            let s = igst_percentages[unique_igst_pct]
            s.igst_amount= s.igst_amount + igst_s_amount
            s.taxable_price = s.taxable_price + taxable_price
            s.total = s.total + total
          }
          else {
            igst_percentages[unique_igst_pct] = {igst_amount:igst_s_amount, taxable_price: taxable_price, total: total}
            //percentages[unique_pct] = {igst_amount:igst_s_amount, cgst_amount:cgst_s_amount, sgst_amount:sgst_s_amount, taxable_price: taxable_price, total: total}
          }

          percentages['igst'] = igst_percentages



      }
      summaryDiscount = parseFloat(summaryDiscount).toFixed(2)
      summaryTaxable = parseFloat(summaryTaxable).toFixed(2)
      summaryIGST = parseFloat(summaryIGST).toFixed(2)
      summaryCGST = parseFloat(summaryCGST).toFixed(2)
      summarySGST = parseFloat(summarySGST).toFixed(2)
      summaryTotal = parseFloat(summaryTotal).toFixed(2)

      let wordsRow, roundOffRow, subTotalRow
      let roundOffValue= parseFloat(purchase.total) - parseFloat(summaryTotal)

      if(roundOffValue >= 0) {
          roundOffValue = "+" + parseFloat(roundOffValue).toFixed(2)
      }
      else {
          roundOffValue = parseFloat(roundOffValue).toFixed(2)
      }
      let mrp_cell, unit_price_cell, exp_date_cell
      if(show_mrp_column) {
        mrp_cell = <td></td>
      }
      if(show_unit_price_column) {
        unit_price_cell = <td></td>
      }
      if(show_expiry_date_column) {
        exp_date_cell = <td></td>
      }

      if(purchase.is_igst) {

        subTotalRow = <tr className="text-right"><td colSpan={table_cols-1}>
        Sub Total
        </td><td>{summaryTotal}</td></tr>
        wordsRow=<tr  key={"words_row_1"}><td className="text-right" colSpan={3}>
        <div className="space-medium-bottom">Total Amount In Words</div></td><td className="text-right" colSpan={table_cols-3} >{inWords(purchase.total)}</td></tr>

        roundOffRow = <tr className="text-right" rowSpan={2} key={"roundoff_row_1"}>
        <td colSpan={table_cols-1} > Round off </td>
        <td>{roundOffValue}</td>
        </tr>

        summaryRow = <tr key={"summary_row"}>
              <td colSpan={3} className="text-right">Total Summary</td><td className="text-right">{summaryQuantity}</td>
              <td></td>
              <td></td>{exp_date_cell}{unit_price_cell}{mrp_cell}<td className="text-right">{summaryDiscount}</td>
              <td className="text-right">{summaryTaxable}</td>
              <td colSpan={"2"} className="text-right">{summaryIGST}</td>
              <td className="text-right">{purchase.total}</td>
        </tr>
      }
      else {
        subTotalRow = <tr key={"sub_total_row"} className="text-right"><td colSpan={table_cols-1}>
        Sub Total
        </td><td>{summaryTotal}</td></tr>
        roundOffRow = <tr className="text-right" rowSpan={2} key={"roundoff_row_1"}>
            <td colSpan={table_cols-1} > Round off </td>
            <td>{roundOffValue}</td>
            </tr>

        wordsRow=<tr  key={"words_row_1"}><td className="text-right" colSpan={3}>
        <div className="space-medium-bottom">Total Amount In Words</div></td><td className="text-right" colSpan={table_cols-3} >{inWords(purchase.total)}</td></tr>
        summaryRow = <tr key={"summary_row"}>
              <td colSpan={3} className="text-right">Total Summary</td><td className="text-right">{summaryQuantity}</td>
              <td></td><td></td>{exp_date_cell}{unit_price_cell}{mrp_cell}<td className="text-right">{summaryDiscount}</td>
              <td className="text-right">{summaryTaxable}</td>
              <td colSpan={"2"} className="text-right">{summaryCGST}</td><td colSpan={"2"} className="text-right">{summarySGST}</td>
              <td className="text-right">{purchase.total}</td>
        </tr>
      }
      items.push(subTotalRow)
      items.push(roundOffRow)
      items.push(summaryRow)
      items.push(wordsRow)


      let taxRowHeaderBase, taxRowHeader,taxSummary

      if(typeof settings !== "undefined" && settings !== null) {

        if(settings.show_purchase_tax_analysis) {
          if(purchase.is_igst) {
            taxRowHeaderBase = <tr className="text-right" key={"tax_row_header_base"}><td colSpan={7} rowSpan={2}></td>
                  <td rowSpan={2}>Taxable Price</td><td className="text-center" colSpan={2}>IGST</td><td rowSpan={2}>Total Tax</td></tr>
            items.push(taxRowHeaderBase)
            taxRowHeader = <tr key={"tax_row_header"}><td>%</td><td>Value</td></tr>
            items.push(taxRowHeader)

            const igstPercentages = percentages['igst']


            let percentageKeys  = Object.keys(igstPercentages)
            let igst_tax_total = 0.0, tax_total=0.0
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })
                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   const s = igstPercentages[pct_key]
                   igst_tax_total = igst_tax_total + parseFloat(s.igst_amount)
                   tax_total = tax_total + parseFloat(s.igst_amount)
                   const igst_amount = parseFloat(s.igst_amount).toFixed(2)
                   const taxable_price = parseFloat(s.taxable_price).toFixed(2)
                   const total = parseFloat(s.igst_amount).toFixed(2)
                   const taxRow = <tr className="text-right" key={"tax_row_"+i}><td colSpan={table_cols-6}></td><td>{taxable_price}</td><td>{pct_key}</td><td>{igst_amount}</td><td>{total}</td></tr>
                   items.push(taxRow)
                 }
            }

            igst_tax_total = parseFloat(igst_tax_total).toFixed(2)
            tax_total = parseFloat(tax_total).toFixed(2)

            taxSummary = <tr key={"tax_footer_row"} className="text-right">
              <td colSpan={table_cols-6}>Tax Summary</td>
              <td>{summaryTaxable}</td>

              <td ></td>
              <td>{igst_tax_total}</td>
              <td>{tax_total}</td>
            </tr>


          }
          else {

            taxRowHeaderBase = <tr className="text-right" key={"tax_row_header_base"}><td colSpan={table_cols-6} rowSpan={2}></td>
                  <td rowSpan={2}>Taxable Price</td><td className="text-center" colSpan={2}>CGST</td>
                  <td className="text-center" colSpan={2}>SGST</td><td rowSpan={2}>Total Tax</td></tr>
            items.push(taxRowHeaderBase)
            taxRowHeader = <tr key={"tax_row_header"}><td className="text-right">%</td><td className="text-right">Value</td><td className="text-right">%</td><td className="text-right">Value</td></tr>
            items.push(taxRowHeader)

            const cgstPercentages = percentages['cgst']
              let cgst_tax_total = 0.0, sgst_tax_total=0.0, tax_total=0.0
            let percentageKeys  = Object.keys(cgstPercentages)
            if(percentageKeys.length > 0 ) {
              percentageKeys.sort((a,b)=>{
                   return a - b
                 })
                 for (var i=0; i<percentageKeys.length; i++) {
                   const pct_key = percentageKeys[i]
                   const s = cgstPercentages[pct_key]
                   cgst_tax_total = cgst_tax_total + parseFloat(s.cgst_amount)
                   sgst_tax_total = sgst_tax_total + parseFloat(s.sgst_amount)
                   tax_total = cgst_tax_total+sgst_tax_total
                   const cgst_amount = parseFloat(s.cgst_amount).toFixed(2)
                   const sgst_amount = parseFloat(s.sgst_amount).toFixed(2)
                   const taxable_price = parseFloat(s.taxable_price).toFixed(2)
                   const total = parseFloat(s.cgst_amount + s.sgst_amount).toFixed(2)
                   const taxRow = <tr className="text-right" key={"tax_row_"+i}>
                   <td colSpan={table_cols-6}></td><td>{taxable_price}</td>
                   <td>{pct_key}</td><td>{cgst_amount}</td>
                   <td>{pct_key}</td><td>{sgst_amount}</td>
                   <td>{total}</td></tr>
                   items.push(taxRow)
                 }
            }

            cgst_tax_total = parseFloat(cgst_tax_total).toFixed(2)
            sgst_tax_total = parseFloat(sgst_tax_total).toFixed(2)
            tax_total = parseFloat(tax_total).toFixed(2)

            taxSummary = <tr key={"tax_footer_row"} className="text-right">
              <td colSpan={table_cols-6}>Tax Summary</td>
              <td>{summaryTaxable}</td>
              <td></td>
              <td>{cgst_tax_total}</td>
              <td></td>
              <td>{sgst_tax_total}</td>
              <td>{tax_total}</td>
            </tr>
          }
          items.push(taxSummary)
        }
      }
    }

    let discount
    if(purchase.totalDiscount > 0) {
      discount = <div className="row">
          <div className="col-xs-6">
            <strong>Discount  </strong>
          </div>
          <div className="col-xs-6 text-right">
             &#8377; {purchase.totalDiscount}
          </div>
      </div>
    }

    let totalBeforeDiscount = parseFloat(parseFloat(purchase.totalPrice) + parseFloat(purchase.totalDiscount)).toFixed(2)
    let cgst_header, sgst_header, igst_header, mrp_header, unit_price_header, exp_header
    if(purchase.is_igst) {
      igst_header = <th colSpan={"2"} className="text-right">IGST</th>
    }
    else {
      cgst_header = <th colSpan={"2"}  className="text-right">CGST</th>
      sgst_header = <th colSpan={"2"} className="text-right">SGST</th>
    }




    let serial = purchase.serial, purchase_label = "PURCHASE"
    let declartion, bankDetails, pan
    if(typeof settings !== "undefined" && settings !== null) {
        if(settings.purchase_label) {
          purchase_label = <span>{settings.purchase_label}</span>
        }
        if(settings.show_purchase_pan) {
          optionalRow= true
          pan = <div>Company Pan - {company.pan}</div>
        }
        if(settings.show_purchase_declaration) {
          optionalRow= true
          declartion = <div><u>Terms and Conditions</u>
              <div><p>{settings.purchase_declaration}</p></div>
      </div>
        }

        if(settings.show_purchase_bankdetails) {
          optionalRow= true
          bankDetails = <div><div className="row">
              <div className="col-xs-6">Bank Name</div>
              <div className="col-xs-6">{company.bank_name}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Account No</div>
                <div className="col-xs-6">{company.account_no}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">IFSC</div>
                <div className="col-xs-6">{company.ifsc_code}</div>
              </div>
              <div className="row">
                <div className="col-xs-6">Branch </div>
                <div className="col-xs-6">{company.branch_name}</div>
              </div>

              </div>
        }


        // if(settings.purchase_serial_prefix.length > 0) {
        //   serial = settings.purchase_serial_prefix+serial
        // }


        serial =  purchase.supplier_bill_no


        if(settings.show_purchase_mrp_column) {
          mrp_header = <th className="text-right">MRP</th>
        }
        else {
          mrp_header = null
        }
        if(settings.show_purchase_unit_price) {
          unit_price_header = <th className="text-right">Unit Price</th>
        }
        else {
          unit_price_header = null
        }

        if(settings.show_invoice_expiry_date) {
          exp_header = <th className="text-right">Exp</th>
        }
        else {
          exp_header = null
        }

    }

    let itemsHeader = <thead>
      <tr className="active">
        <th>S.No</th>
        <th className="table-item">Item Name</th>
        <th className="table-item">HSN</th>
        <th className="text-right">Qty</th>
        <th className="table-item">UOM</th>
        <th>Batch</th>
        {exp_header}
        {unit_price_header}
        {mrp_header}
        <th className="text-right">Discount</th>
        <th className="text-right">Taxable Price</th>
        {cgst_header}{sgst_header}{igst_header}
        <th className="text-right">Total</th>
      </tr>
    </thead>

    let termsAndBankRow =  <tr key={"terms_row_1"}>
      <td colSpan={table_cols}>
      <div className="row">
        <div className="col-xs-6">
        {pan}
        {declartion}
        </div>
        <div className="col-xs-6 text-right">
        {bankDetails}
        </div>
      </div>
      </td>
      </tr>

    if(optionalRow) {
        items.push(termsAndBankRow)
    }

    let signatureRow = <tr key={"signature_row"}>
    <td colSpan={table_cols}>
    <div className="row">
      <div className="col-xs-6">

      </div>
      <div className="col-xs-6 text-right">
          <div className="space-medium-bottom">For {company.company_name}</div>

          <div>Authorized Signature</div>
      </div>
    </div>
    </td>
    </tr>

    items.push(signatureRow)






      return <div  className="pharma-a5" >

              <div className="row">
              <div className="col-xs-5">
                {billFrom}
                </div>

                <div className="col-xs-4">

                              {billto}
                </div>
                <div className="col-xs-3">
                <div className="invoice-name text-right">
                  {purchase_label}
                </div>
                <div className="text-right invoice-name">{serial}</div>
                  <div className="gray text-right">
                  Date: {purchase_date}
                  </div>
                </div>

              </div>


              <div className="row">
              <div className="col-xs-12">
              <table className="table table-bordered table-condensed">
              {itemsHeader}
                <tbody>
                  {items}
                </tbody>

              </table>
              </div>
              </div>


              <div className="row space-small hidden">
              <div className="col-xs-6 col-xs-offset-6">

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>Amount  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {totalBeforeDiscount}
                      </div>
                  </div>

                  {discount}

                  <div className="row">
                      <div className="col-xs-6">
                        <strong>GST  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {purchase.totalTax}
                      </div>
                  </div>

                  <div className="row">
                      <div className="col-xs-6">
                      <strong>Total  </strong>
                      </div>
                      <div className="col-xs-6 text-right">
                         &#8377; {purchase.total}
                      </div>
                  </div>

              </div>
              </div>
              <div className="row">
                <div className="col-xs-12">
                {brandRow}
                </div>

              </div>


      </div>

  }
}

export default PurchasePharma



// WEBPACK FOOTER //
// ./src/components/purchase/previews/purchasepharma.js